import React from 'react';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import copyTokens from '@amzn/meridian-tokens/base/icon/copy';
import './CopyToClipboardButton.css';

const CopyToClipboardButton = ({ value, copyLabel = 'Copy plan ID', size = 'small' }) => {
  if (!value) return null;
  const small = size === 'small';
  return (
    <Button
      type="link"
      size={size}
      className={small ? 'copy-to-clipboard-button-small' : undefined}
      onClick={() => navigator.clipboard?.writeText(String(value)).catch(() => {})}>
      <Icon tokens={copyTokens} className={small ? 'copy-to-clipboard-icon-small' : undefined}>
        {copyLabel}
      </Icon>
    </Button>
  );
};

export default CopyToClipboardButton;
